import { createSelector } from 'reselect';
import { WidgetChatState } from 'slices/modules/chat/widgetChatSlice';
import { RootState } from 'store';

export const selectedWidgetChatSelector = createSelector(
  (state: RootState): WidgetChatState => state.selectedChat,
  (data) => data.selectedChat
);

export const isWidgetChatOpenedSelector = createSelector(
  (state: RootState): WidgetChatState => state.selectedChat,
  (data) => data.isOpened
);
